import React from "react";
import { getViewInfo } from "src/common/attrView";
import {
  makeSimpleTextProps,
  makeTagProps,
} from "src/common/attrView/componentsDefs";
import { seedSeparators } from "src/common/attrView/viewFormItems/Separator";
import { MakeLabelParams } from "../types/MakeLabelParams";
import { getAttrLabelTreeData } from "../utils/getAttrLabelTreeData";
import { SimpleText } from "./SimpleText/SimpleText";
import { Tag } from "./Tag/Tag";

export const defineSimpleLabel = (params: MakeLabelParams) => {
  const { attribute } = params;
  const attrTreeData = getAttrLabelTreeData(
    params.attribute,
    params.labelTreeData,
  );
  const viewInfo = getViewInfo(attribute.viewType);
  if (!attrTreeData || attrTreeData.labels?.length === 0 || !viewInfo)
    return null;

  const newValues = seedSeparators(
    (attrTreeData.labels || []).map((v, i) => ({ content: v, key: i })),
    viewInfo?.appearance?.view?.separator,
  );
  return <SimpleText {...makeSimpleTextProps(newValues, viewInfo)} />;
};

export const defineTagLabel = (params: MakeLabelParams) => {
  const { attribute } = params;
  const attrTreeData = getAttrLabelTreeData(
    params.attribute,
    params.labelTreeData,
  );
  const viewInfo = getViewInfo(attribute.viewType);
  if (
    !attrTreeData ||
    attrTreeData.labels?.length === 0 ||
    !viewInfo ||
    viewInfo.component?.view !== "Tag"
  )
    return null;
  const newValues = seedSeparators(
    (attrTreeData.labels || []).map((v, i) => ({ content: v, key: i })),
    viewInfo?.appearance?.view?.separator,
  );
  return <Tag {...makeTagProps(viewInfo.component, newValues, viewInfo)} />;
};
